import React from 'react';
import { styled } from 'styled-components';
import { Photo } from 'Compass/profile-lab/types';
import { formatCoords, formatDate } from 'Compass/profile-lab/utils/assetFormatting';

interface ImageTileProps {
  asset: Photo;
  imageUrl?: string;
  textLines?: string[];
  width?: number;
  height?: number;
}

const ImageTile: React.FC<ImageTileProps> = ({
  asset,
  imageUrl = '',
  textLines = [],
  width = 200,
  height = 200
}) => {

  const metadata = [
    formatDate(asset.photo_date),
    formatCoords(asset.latitude, asset.longitude),
    ...textLines
  ];

  return (
    <ImageContainer $width={width} $height={height} $imageUrl={imageUrl}>
      <TextOverlay $status={asset.status || 'none'}>
        {metadata.map((line, idx) => (
          <TextLine key={idx}>{line}</TextLine>
        ))}
      </TextOverlay>
    </ImageContainer>
  );
};

const ImageContainer = styled.div<{ $width: number; $height: number; $imageUrl: string }>`
  position: relative;
  width: ${props => props.$width}px;
  height: ${props => props.$height}px;
  background-image: url('${props => props.$imageUrl}');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const TextOverlay = styled.div<{ $status: 'selected' | 'grow' | 'none' }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  font-size: 12px;

  ${props => {
    switch (props.$status) {
      case 'selected':
        return `
          background-color: rgba(147, 51, 234, 0.9);
          color: white;

          a {
            color: white;
            text-decoration: underline;
          }
        `;
      case 'grow':
        return `
          background-color: rgba(16, 185, 129, 0.9);
          color: white;

          a {
            color: white;
            text-decoration: underline;
          }
        `;
      default:
        return `
          background-color: rgba(255, 255, 255, 0.9);
          color: #2d3748;
        `;
    }
  }}
`;

const TextLine = styled.div`
  font-size: 12px;
  line-height: 1.4;
`;

export default ImageTile;
